<div class="main-page">
    <h1 class="page-title">Help Desk</h1>
    <p class="sub-text title-border-wrap">Need help? Contact ThinkBio.Ai Support Team for any issues or assistance<span class="title-border"></span></p>
    <div class="contact-details-wrap">
        <h5 class="sub-title">Contact Details</h5>
        <div class="d-flex">
          <div class="contact-details">
            <img src="./assets/images/icons/mail-icon.svg" alt="mail icon">
            <div class="ms-3">
              <h5>Support Email</h5>
              <p>You can reach out to us at<br>
                <a class="link" href="mailto:simiscosupport&#64;thinkbio.ai">simiscosupport&#64;thinkbio.ai</a> for any inquiries.</p>
            </div>
          </div>
          <div class="contact-details">
            <img src="./assets/images/icons/phone-icon.svg" alt="phone icon">
            <div class="ms-3">
              <h5>Toll Free Number (For US only)</h5>
              <p>Feel free to contact us toll-free at<br>
                 1-800-123-4567 for any questions.</p>
            </div>
          </div>
        </div>
    </div>
  <div class="request-wrap">
    <h5 class="sub-title title-border-wrap">How to Raise a Request<span class="title-border"></span>
      <button class="btn btn-outline-blue btn-sample ms-3" (click)="openModal()">View sample email </button>
    </h5>
    <ul>
      <li>Use your Simisco domain email ID</li>
      <li>Mention module / feature name impacted (Eg:Project, /Inventory)</li>
      <li>Add steps to reproduce the issue</li>
      <li>Attach screenshots / error messages</li>
      <li>Please select the severity level below and include the chosen severity (Eg: Medium ) in the email subject.
      </li>
    </ul>
  </div>
  <div class="severity-wrap">
    <h5 class="sub-title title-border-wrap">Select Severity<span class="title-border"></span></h5>
    <ul>
      <li>
        <span class="round-icon critical"></span>
        <p><span class="title">Critical</span>
          Complete system outage or major functionality not working</p>
      </li>
      <li>
        <span class="round-icon high"></span>
        <p>
          <span class="title">High</span>
          Significant system degradation or key feature not working
        </p>
      </li>
      <li>
        <span class="round-icon medium"></span>
        <p>
          <span class="title">Medium</span>
          Partial functionality issue
        </p>
      </li>
      <li>
        <span class="round-icon"></span>
        <p>
          <span class="title">Low</span>
          Minor issue, UI bug, or general query
        </p>
      </li>
    </ul>
  </div>
  <div class="footer-note">
    <img src="./assets/images/icons/sticky-note.svg" alt="note icon">
    <div class="ms-3">
      <label for="">Note</label>
      <p>Please select the appropriate severity level based on the issue impact to help us prioritize your request.</p>
    </div>
  </div>
</div>

@if(isModalOpen) {
  <app-email-template-modal #emailModal (closePopup)="closeModal()"></app-email-template-modal>
}